module.exports = __webpack_public_path__ + "images/emoji/mega.102f53d1ea7e1b0a5e05.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mega.png
// module id = wSg9
// module chunks = 1